import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FormActions } from '../../../components/form/index.js';
import Table from '../../../components/Table.tsx';
import { useFeedbacksContext } from '../../../contexts/feedbacks/feedbacks.tsx';

const FeedbacksBody = () => {
    const { feedbacks, deleteFeedback } = useFeedbacksContext();
    const navigate = useNavigate();
    const columns = [
        {
            header: "name",
            name: "name",
            enableSorting: true,
            cell: (props: any) => {
                const { feedbackID, name } = props.row;
                return (
                    <Link className="nav-link" to={`/feedbacks/${feedbackID}`}>
                        <span >{name}</span>
                    </Link>
                );
            }
        },
        {
            header: "",
            name: "delete",
            actionHandler: (props: any) => {
                const { feedbackID } = props.row;
                return deleteFeedback(feedbackID);
            },
            enableSorting: false
        }
    ]

    return (
        <>
            <Table columns={columns} rows={feedbacks} />
            <FormActions
                mainAction={() => { navigate("/feedbacks/create"); }}
                mainActionText="Create"
            />
        </>
    );
};

export default FeedbacksBody;